import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api, formatPrice } from "@/lib/api";

export default function PaymentSupplementPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (!token) return setResult({ status: "error" });
    api.post(`/payments/supplement/${token}/capture`).then(({ data }) => setResult(data)).catch(() => setResult({ status: "error" }));
  }, [token]);

  return (
    <div data-testid="supplement-page" className="mx-auto max-w-xl px-6 py-24 text-center">
      {!result ? (
        <p data-testid="supplement-verifying" className="flex items-center justify-center gap-2 text-bark-soft"><Loader2 className="animate-spin" /> Vérification du paiement…</p>
      ) : result.status === "paid" ? (
        <div data-testid="supplement-paid" className="space-y-4">
          <CheckCircle2 size={56} className="mx-auto text-sage" />
          <h1 className="font-serif text-4xl font-semibold text-bark">Merci, c'est réglé !</h1>
          <p className="text-bark-soft">Le complément de {formatPrice(result.amount_cents)} pour la commande n° {result.order_ref} est bien payé.</p>
        </div>
      ) : (
        <div data-testid="supplement-failed" className="space-y-4">
          <XCircle size={56} className="mx-auto text-terra" />
          <h1 className="font-serif text-4xl font-semibold text-bark">Paiement non finalisé</h1>
          <p className="text-bark-soft">Le paiement n'a pas pu être confirmé. Réessayez depuis le lien reçu par e-mail ou contactez-nous.</p>
        </div>
      )}
      <Link to="/" data-testid="supplement-home-link" className="mt-8 inline-block rounded-full bg-amber-deep px-6 py-2.5 text-sm font-semibold text-white hover:bg-honey">Retour à la boutique</Link>
    </div>
  );
}
